.animated-gradient-button {
  --btn-dark-tint: color-mix(
    in srgb,
    rgb(var(--repeatmd-brand-color, 29, 27, 167)) 100%,
    rgb(var(--repeatmd-brand-tint, 35, 95, 215)) 0%
  );

  background:
    radial-gradient(circle at 30% 50%, var(--btn-dark-tint) 0%, transparent 60%),
    radial-gradient(circle at 70% 50%, var(--btn-dark-tint) 0%, transparent 60%),
    rgb(var(--repeatmd-brand-color, 29, 27, 167));
  background-size:
    150% 100%,
    150% 100%,
    100% 100%;
  background-position:
    0% 50%,
    100% 50%,
    0% 0%;
  animation: dark-luxury-gradient 18s ease-in-out infinite;
}

@supports (color: rgb(from white r g b)) {
  .animated-gradient-button {
    --btn-dark-tint: rgb(
      from rgb(var(--repeatmd-brand-tint, 35, 95, 215)) calc(r * 0.7) calc(g * 0.7) calc(b * 0.7)
    );
  }
}

.animated-gradient-button {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.animated-gradient-button:active {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

@keyframes dark-luxury-gradient {
  0% {
    background-position:
      0% 50%,
      100% 50%,
      0% 0%;
  }
  50% {
    background-position:
      100% 50%,
      0% 50%,
      0% 0%;
  }
  100% {
    background-position:
      0% 50%,
      100% 50%,
      0% 0%;
  }
}
